let CurrencyCodes = {
    COP: "170",
    CLP: "152",
    BRL: "986",
    SVC: "222",
    USD: "840",
    USS: "998",
    USN: "997",
    MXN: "484",
    MXV: "979",
    NIO: "558",
    PEN: "604",
    VEF: "937",
    ARS: "032"
};

export default CurrencyCodes;